import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router';

import { LoaderDialog } from '../../components/LoaderDialog/LoaderDialog';
import { useBankContext, useBrandContext } from '../../dictionaries/context/BankContext';
import { useCountryContext } from '../../dictionaries/context/CountryContext';
import { useConfirmIdentityOneTimeLinkMutation, useGetOneTimeLinkQuery } from '../../generated/graphql';
import { session } from '../../utils/auth';
import { initialRoute } from '../../utils/initialRoute';

function OneTimeLink() {
  const history = useHistory();
  const [ , setBrand ] = useBrandContext();
  const [ , setCountry ] = useCountryContext();
  const [ , setBank ] = useBankContext();
  const { id } = useParams<{ id: string }>();
  const [
    confirmIdentity,
    { data: identity, error: identityError },
  ] = useConfirmIdentityOneTimeLinkMutation();
  const { data, loading: loadingOTL, error: OTLError } = useGetOneTimeLinkQuery({
    variables: {
      id,
    },
  });

  const { payload: { redirectTo = '', brand = undefined, country = undefined, bank = undefined } = {} } = data?.getOneTimeLink || {};

  useEffect(() => {
    if (brand) setBrand(brand);
    if (country) setCountry(country);
    if (bank) setBank(bank);
  }, [ brand, bank, country, setBank, setBrand, setCountry ]);

  // If there is no OTL with such id, or identity could not be done
  // we redirect to root path
  useEffect(() => {
    if (OTLError || identityError) history.replace('/portal/validacion-identidad/ingresar');
  }, [ history, identityError, OTLError ]);

  useEffect(() => {
    if (loadingOTL) return;

    // we save the path to redirect, in case the user has to manually validate identity
    if (redirectTo) initialRoute.set(redirectTo);

    confirmIdentity({
      variables: {
        id,
      },
    });
  }, [ confirmIdentity, history, id, redirectTo, loadingOTL ]);

  useEffect(() => {
    if (!identity) return;

    const { access } = identity.confirmIdentityOneTimeLink;
    session.setAccessToken(access);

    history.replace(initialRoute.get());
  }, [ identity, history ]);

  return <LoaderDialog open />;
}

export default OneTimeLink;
